import { type FC, type ReactNode } from "react";

export const ActionBar: FC<{
  children: ReactNode;
}> = ({ children }) => (
  <div className="flex items-center justify-end gap-2 border-b border-slate-200 bg-slate-50 px-4 py-2">
    {children}
  </div>
);
